import {
  phoneCountryCodeOptions,
} from "../../../shared/config/phoneOptions";

const inputClass =
  "mt-1 block w-full rounded-xl border border-slate-300 bg-white px-3.5 py-2.5 text-sm text-slate-900 shadow-sm outline-none transition focus:border-amber-500 focus:ring-2 focus:ring-amber-500/20 disabled:bg-slate-50";

const Field = ({
  label,
  required = false,
  children,
}) => (
  <label className="block text-sm font-medium text-slate-700">
    <span>
      {label}
      {required && (
        <span className="ml-1 text-red-600">
          *
        </span>
      )}
    </span>
    {children}
  </label>
);

const ContactAccountSection = ({
  formData,
  updateField,
  handlePhoneChange,
  availability,
  availabilityChecking,
  onPhoneBlur,
}) => (
  <div className="grid gap-5 md:grid-cols-2">
    <Field
      label="Verified Email ID"
      required
    >
      <div className="relative">
        <input
          type="email"
          value={formData.email}
          readOnly
          className={`${inputClass} pr-24`}
        />
        <span className="absolute right-3 top-1/2 -translate-y-1/2 rounded-full bg-emerald-100 px-2.5 py-1 text-xs font-semibold text-emerald-700">
          Verified
        </span>
      </div>
    </Field>

    <Field
      label="Phone Number"
      required
    >
      <div className="grid grid-cols-[165px_1fr] gap-2">
        <select
          name="phoneCountryCode"
          value={
            formData.phoneCountryCode ||
            "+91"
          }
          onChange={
            handlePhoneChange
          }
          className={inputClass}
        >
          {phoneCountryCodeOptions.map(
            (option) => (
              <option
                key={`${option.iso2}-${option.code}`}
                value={option.code}
              >
                {option.label}
              </option>
            )
          )}
        </select>

        <input
          type="tel"
          name="phoneNumber"
          value={
            formData.phoneNumber
          }
          onChange={
            handlePhoneChange
          }
          onBlur={onPhoneBlur}
          inputMode="numeric"
          maxLength={10}
          className={inputClass}
          placeholder="10-digit mobile number"
        />
      </div>

      <div className="mt-1.5 min-h-[18px] text-xs">
        {availabilityChecking?.phone ? (
          <span className="text-slate-500">
            Checking phone availability...
          </span>
        ) : availability?.phone ===
          "taken" ? (
          <span className="font-medium text-red-600">
            This phone number is already registered.
          </span>
        ) : availability?.phone ===
          "free" ? (
          <span className="font-medium text-emerald-700">
            Phone number is available.
          </span>
        ) : null}
      </div>
    </Field>

    <Field
      label="Date of Birth"
      required
    >
      <input
        type="date"
        name="dob"
        value={formData.dob}
        onChange={updateField}
        className={inputClass}
      />
    </Field>

    <div className="hidden md:block" />

    <Field
      label="Password"
      required
    >
      <input
        type="password"
        name="password"
        value={formData.password}
        onChange={updateField}
        className={inputClass}
        autoComplete="new-password"
      />
      <p className="mt-1.5 text-xs text-slate-500">
        Minimum 8 characters with uppercase, lowercase, number and special character.
      </p>
    </Field>

    <Field
      label="Confirm Password"
      required
    >
      <input
        type="password"
        name="confirmPassword"
        value={
          formData.confirmPassword
        }
        onChange={updateField}
        className={inputClass}
        autoComplete="new-password"
      />
    </Field>
  </div>
);

export default ContactAccountSection;
